/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchFilterLocation
 */
export interface SourcingSearchFilterLocation {
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterLocation
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterLocation
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterLocation
     */
    distanceRadiusInKilometers?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchFilterLocation
     */
    shouldMatchAlternativeLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchFilterLocation
     */
    shouldMatchRemoteOnlyFreelancers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchFilterLocation
     */
    shouldMatchWillingToTravelFreelancers?: boolean;
}

/**
 * Check if a given object implements the SourcingSearchFilterLocation interface.
 */
export function instanceOfSourcingSearchFilterLocation(value: object): value is SourcingSearchFilterLocation {
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function SourcingSearchFilterLocationFromJSON(json: any): SourcingSearchFilterLocation {
    return SourcingSearchFilterLocationFromJSONTyped(json, false);
}

export function SourcingSearchFilterLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilterLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'distanceRadiusInKilometers': json['distanceRadiusInKilometers'] == null ? undefined : json['distanceRadiusInKilometers'],
        'shouldMatchAlternativeLocations': json['shouldMatchAlternativeLocations'] == null ? undefined : json['shouldMatchAlternativeLocations'],
        'shouldMatchRemoteOnlyFreelancers': json['shouldMatchRemoteOnlyFreelancers'] == null ? undefined : json['shouldMatchRemoteOnlyFreelancers'],
        'shouldMatchWillingToTravelFreelancers': json['shouldMatchWillingToTravelFreelancers'] == null ? undefined : json['shouldMatchWillingToTravelFreelancers'],
    };
}

export function SourcingSearchFilterLocationToJSON(value?: SourcingSearchFilterLocation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'distanceRadiusInKilometers': value['distanceRadiusInKilometers'],
        'shouldMatchAlternativeLocations': value['shouldMatchAlternativeLocations'],
        'shouldMatchRemoteOnlyFreelancers': value['shouldMatchRemoteOnlyFreelancers'],
        'shouldMatchWillingToTravelFreelancers': value['shouldMatchWillingToTravelFreelancers'],
    };
}

